import { Config } from "../parhato2/config";

export const getStaticShippingMethods = (zoneId: string) => {
  const shippingZoneMethods = Config.staticOrderData?.shippingZoneMethods || [];
  const shippingMethods = Config.staticOrderData?.shippingMethods || [];

  const filteredShippingMethods = shippingZoneMethods
    .filter((shippingZoneMethod) => String(shippingZoneMethod.shippingZoneId) === zoneId)
    .map((shippingZoneMethod) =>
      shippingMethods.find((m) => String(m.methodId) === String(shippingZoneMethod.shippingMethodId)),
    )
    .filter((m): m is NonNullable<typeof m> => Boolean(m));

  return filteredShippingMethods;
};
